import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, ReverIntegrationResponseDataSchema } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof ReverIntegrationResponseDataSchema>>

const queryKey = ["reverIntegration"]

export const reverIntegrationQuery = () => {
  return queryOptions({
    queryKey,
    queryFn: async () => {
      const response = await axios.get<Response>(`/integrations/rever/configuration`)

      return response.data.data
    },
  })
}
